import axios from "axios";
const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
};

// SECURITY NOTE: The admin token is stored in localStorage.
// This is an acceptable trade-off for this app because:
//   1. The admin area is accessed only by trusted internal operators (not public customers).
//   2. React escapes all output by default — our codebase has no dangerouslySetInnerHTML on user input.
//   3. The token is short-lived (JWT exp in backend), scoped to a single endpoint set (/api/admin/*).
// For a stronger posture (defense in depth against XSS token theft), migrate to httpOnly cookies:
//   - Backend: Set-Cookie: admin_token=...; HttpOnly; Secure; SameSite=Strict on /api/admin/login.
//   - Frontend: axios({ withCredentials: true }); remove localStorage read/write.
//   - CORS: switch allow_origins from "*" to the exact frontend origin (required by browsers when credentials=true).
const stored = localStorage.getItem("admin_token");
if (stored) setAuthToken(stored);
